import moment from "moment";
import { useState } from "react";

export const useHeaderActions = () => {
  const [selectedClinic, setSelectedClinic] = useState({
    value: 0,
    label: "All Clinics",
  });

  const [period, setPeriod] = useState({
    fromDate: moment().startOf("month").toDate(),
    toDate: moment().endOf("month").toDate(),
  });

  const [exportType, setExportType] = useState(null);

  return {
    selectedClinic: {
      value: selectedClinic,
      update: setSelectedClinic,
    },
    period: {
      value: {
        fromDate: period.fromDate,
        toDate: period.toDate,
      },
      update: setPeriod,
    },
    apiPeriod: {
      fromDate: moment(period.fromDate).format("YYYY-MM-DD"),
      toDate: moment(period.toDate).format("YYYY-MM-DD"),
    },
    exportType: {
      value: exportType,
      update: setExportType,
    },
  };
};
